/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   3/23/22
 */

import {gql} from "urql";
import {ListResponse, WorkdayEvent} from "../../interfaces/Global";

export const WorkdayEventsQuery = gql`
	query WorkdayEvents($employees: [String!]!) {
		workdayEvents(employees: $employees) {
			total
			items {
				id
				typeId
				employeeId
				startDatetime
				endDatetime
            }
		}
	}
`;

export interface WorkdayEventsResponse {
	workdayEvents: ListResponse<WorkdayEvent>
}

export interface WorkdayEventsQueryVars {
	employees: string[]
}